<script lang="ts" setup>
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import messages from '@/locales/about/messages.ts'

const { t, locale, fallbackLocale } = useI18n({
    useScope: 'global',
    messages: messages
});
onMounted(()=>{
    console.log('messages',messages)
})
// we get the fallback language
function getTranslation(key){
    // we split the key by '.' to get the index for each message and check if it exists in the locale if not we provide it in the fallback locale
    const keys = key.split('.')
    let current = messages[locale.value]
    let fallback = messages[fallbackLocale.value]
    if(!current){
        current = fallback
    }
    for(let i = 0; i < keys.length; i++){
        if(current[keys[i]]){
            current = current[keys[i]]
            fallback = fallback[keys[i]]
        }
        else{
            fallback = fallback[keys[i]]
            current = fallback
        }
    }
    return current
}


</script>
<template>
    <div id="category_header">
        <img src="/img/about/background.jpg" alt="KaseFilters.fr" />
        <h1>{{ $t('about-title') }}</h1>
    </div>
    <div class="content">
        <template v-for="(block, index) in messages.fr.about" :key="index">
            <h1 v-if="block.type === 'title'">{{ getTranslation('about.'+index+'.content') }}</h1>
            <h2 v-if="block.type === 'title2'">{{ getTranslation('about.'+index+'.content') }}</h2>
            <p v-else-if="block.type === 'paragraph'">{{ getTranslation('about.'+index+'.content') }}</p>
            <div v-else-if="block.type === 'bold'"><b>{{ getTranslation('about.'+index+'.content') }}</b></div>
            <em v-else-if="block.type === 'italic'">{{ getTranslation('about.'+index+'.content') }}</em>
            <ul v-else-if="block.type === 'list' && block.variant!='ol'">
                <li v-for="(item, idx) in block.items" :key="idx">{{ getTranslation('about.'+index+'.items.'+idx) }}</li>
            </ul>
            <ol v-else-if="block.type === 'list' && block.variant==='ol'">
                <li v-for="(item, idx) in block.items" :key="idx">{{ getTranslation('about.'+index+'.items.'+idx) }}</li>
            </ol>
        </template>
    </div>
</template>
<style lang="scss" scoped>
#category_header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 190px;
    width: 100%;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
    h1{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 30px;
        font-weight: 700;
        line-height: 36.57px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
    h2{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 20px;
        font-weight: 400;
        line-height: 25px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
}
    .row{
        flex-wrap: wrap;
    }
    h1, h2{
        margin-bottom: 10px;
    }
    div{
        margin-bottom: 10px;
    }
    p{
        margin-bottom: 10px;
        margin-top: 10px;
    }
    ol, ul{
        margin-bottom: 10px;
        margin-top: 10px;
        margin-left: 20px;
    }
    @media only screen and (min-width : $responsive-point) {
        .row{
            flex-wrap: nowrap;
        }
    }
</style>
<route lang="yaml">
name: aboutus
props: true
meta:
    title: A propos de KaseFilters France
    layout: default
    description: Découvrez KaseFilters France
    middleware: guest
</route>